import React from 'react'

const NoResults = () => (
  <div className="ant-empty search-table__empty">
    <div className="ant-empty-description">No results</div>
  </div>
)

export default NoResults
